export const regionSelect = selectedRegion => {
  return {
    type: "REGION_SELECT",
    payload: selectedRegion
  };
};
